import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import './index.scss';

const LogSeviceCamera = ({ dataDevice }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { namespace, servicesCamera } = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataDevice) {
      setIsLoading(true)
      onLogService(dataDevice?.serial)
    }
  }, [dataDevice]);

  useEffect(() => {
    if (servicesCamera) {
      setTimeout(() => {
        setIsLoading(false)
      }, 300);
    }
  }, [servicesCamera]);

  const onLogService = async (serial) => {
    const timeRequest = new Date().getTime()
    let data = {
      timeRequest,
      namespace,
      serial,
    };
    let dataObj = {
      appServiceType: SERVICE.LIST_SERVICE_BY_DEVICE_SERIAL,
      requestId: timeRequest,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  }

  return (
    <div className="log-service-camera-page">
      <div className="table-page">
        <Table
          loading={isLoading}
          size="small"
          dataSource={
            servicesCamera?.filter(item => item.licenseCode)?.map((device, key) => ({
              ...device,
              key,
            }))
          }
          columns={[
            {
              title: t('Name'),
              dataIndex: 'name',
              key: 'name_device',
            },
            {
              title: t('Active date'),
              key: 'log_activatedAt',
              dataIndex: 'activatedAt',
              render: (name) =>
                name ? moment(name, 'YYYY-MM-DD').format('DD-MM-YYYY') : '',
            },
            {
              title: t('License code'),
              dataIndex: 'licenseCode',
              key: 'licenseCode',
            },
          ]}
        />
      </div>
    </div>
  );
}

export default LogSeviceCamera;
